export enum OrganismeProjection {
  DEFAULT = 'DEFAULT',
  DEMANDE_ACTION = 'DEMANDE_ACTION',
  DETAILS = 'DETAILS',
  STATE = 'STATE',
  STATUT = 'STATUT',
  NOM = 'NOM',
  ANNUAIRE = 'ANNUAIRE', // Parcours FC - Annuaire
  SUIVI_DEPOT_SIREN = 'SUIVI_DEPOT_SIREN', // Parcours FC - Campagne - Suivi dépôt en vue SIREN
  INSCRIPTION = 'INSCRIPTION',
}